import { serverError } from '@/locales/pt-br/errors'

export default {
  title: 'Sites',
  usage: 'Sites: {consumed} de {limit}',
  headerAction: 'Criar Novo Site',
  filter: {
    label: 'Busque um site',
    placeholder: 'Digite o site que procura'
  },
  site: {
    createAt: 'Criado em {date}',
    status: {
      active: 'Site Ativo',
      activating: 'Instalando Site',
      deactivated: 'Desativado',
      deleting: 'Excluindo Site'
    },
    ssl: {
      false: 'Certificado SSL Não Ativado',
      activating: 'Ativando Certificado SSL',
      true: 'Certificado SSL Ativado'
    },
    domainStatus: {
      false: 'Domínio Aguardando Configuração',
      true: 'Domínio Configurado'
    },
    statusCdn: {
      true: 'Site Ativo - CDN Habilitado'
    },
    menu: {
      email: 'Painel de Email',
      password: 'Alterar senha',
      domain: 'Alterar domínio',
      backup: 'Backup/Restore',
      cdn: { true: 'Desativar CDN', false: 'Ativar CDN' },
      delete: 'Excluir site'
    },
    actions: {
      manage: 'Editar Site',
      menu: 'Opções do site'
    },
    link: {
      pluginsSuggestion: 'Ver sugestão de plugins'
    }
  },
  result: {
    error: serverError,
    notFound: {
      title: 'Plano encontrado não encontrado',
      action: 'Listar Zonas'
    },
    empty: {
      title: 'Boas-vindas, {name}! Vamos criar seu primeiro site?',
      description: 'Você ainda não possui sites neste plano.',
      action: 'Criar Novo Site'
    }
  }
}
